import { motion } from 'motion/react'
import { EmptyStateBlock, customerMotionTransition } from '../customer-area'
import { PackageIcon, SearchIcon } from './ordersListShared'
import type { TranslateFn } from './ordersListSectionTypes'

type OrdersResultsEmptyStateProps = {
  reducedMotion: boolean
  ordersCount: number
  onOpenCatalog: () => void
  onClearAllFilters: () => void
  t: TranslateFn
}

export const OrdersResultsEmptyState = ({
  reducedMotion,
  ordersCount,
  onOpenCatalog,
  onClearAllFilters,
  t,
}: OrdersResultsEmptyStateProps) => (
  <motion.div
    key="orders-empty"
    initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
    animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
    exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
    transition={customerMotionTransition}
    className="flex min-h-[14rem] items-center px-5 py-7 sm:min-h-[15rem] lg:min-h-[16rem]"
  >
    <EmptyStateBlock
      icon={ordersCount === 0 ? <PackageIcon className="h-4 w-4" /> : <SearchIcon className="h-4 w-4" />}
      title={ordersCount === 0 ? t('customer.orders.emptyTitle') : t('customer.orders.noMatchTitle')}
      description={ordersCount === 0 ? t('customer.orders.emptyDescription') : t('customer.orders.noMatchDescription')}
      action={
        ordersCount === 0 ? (
          <motion.button
            type="button"
            onClick={onOpenCatalog}
            whileTap={reducedMotion ? undefined : { scale: 0.985 }}
            transition={customerMotionTransition}
            className="ca-btn-primary inline-flex h-10 items-center px-4 text-sm font-semibold"
          >
            {t('customer.orders.emptyCta')}
          </motion.button>
        ) : (
          <motion.button
            type="button"
            onClick={onClearAllFilters}
            whileTap={reducedMotion ? undefined : { scale: 0.985 }}
            transition={customerMotionTransition}
            className="ca-btn-secondary inline-flex h-9 items-center px-3 text-sm font-semibold"
          >
            {t('customer.orders.filters.reset')}
          </motion.button>
        )
      }
    />
  </motion.div>
)
